"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = _interopRequireDefault(require("../styles"));
var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _excluded = ["classes"];
var styles = {
  root: {}
};

/**
 * Use `CircularProgress` to indicate work is being done "behind the scenes" when a user initiates a call to action (loading, working, etc).
 * @done true
 * @updated v7.0.0
 * @versionAdded v0.0.8
 * @examples
 *  CircularProgressIndeterminate
 *  CircularProgressDeterminate
 */
var CircularProgress = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var classes = props.classes,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var classOverrides = {
    // Necessary style overrides are set here
    // See Material UI documentation for available CSS classes to override
    root: classes.root
  };
  return /*#__PURE__*/_react.default.createElement(_CircularProgress.default, (0, _extends2.default)({}, rest, {
    classes: classOverrides,
    ref: ref
  }));
});
CircularProgress.muiName = 'CircularProgress';
CircularProgress.displayName = 'CircularProgress';
CircularProgress.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * The color of the component.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary', 'inherit']),
  /**
   * If `true`, the shrink animation is disabled. This only works if variant is `indeterminate`.
   */
  disableShrink: _propTypes.default.bool,
  /**
  * The size of the circle.
  * If using a number, the pixel unit is assumed.
  * If using a string, you need to provide the CSS unit, e.g '3rem'.
  */
  size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  /**
   * @ignore
   */
  style: _propTypes.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.bool])), _propTypes.default.func, _propTypes.default.object]),
  /**
   * The thickness of the circle.
   */
  thickness: _propTypes.default.number,
  /**
   * The value of the progress indicator for the `determinate` variant.
   * Value between 0 and 100.
   */
  value: _propTypes.default.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   */
  variant: _propTypes.default.oneOf(['determinate', 'indeterminate'])
};
CircularProgress.defaultProps = {
  color: 'primary',
  disableShrink: false,
  size: 40,
  thickness: 3.6,
  value: 0,
  variant: 'indeterminate'
};
var _default = exports.default = (0, _styles.default)(styles)(CircularProgress);